import * as z from "zod";

const ShopifyMetafieldSchema_ = z.object({
  type: z.string(),
  namespace: z.string(),
  key: z.string(),
  value: z.string(),
});
export const ShopifyMetafieldSchema: z.ZodType<ShopifyMetafield> =
  ShopifyMetafieldSchema_;
export interface ShopifyMetafield
  extends z.infer<typeof ShopifyMetafieldSchema_> {}

export const REDO_METAFIELD_NAMESPACE = "redo";
export const REDO_ID_METAFIELD_KEY = "id";
export const REDO_ID_METAFIELD_TYPE = "id";
